import { Box, Grid, Typography } from "@material-ui/core";
import { FormLoginCliente } from "components/forms/form-login-cliente/form-login-cliente";
import { DefaultFormRefs } from "components/forms/utils";
import { InputPin } from "components/inputs/input-pin";
import { TextFieldSaurus } from "components/inputs/text-field-saurus";
import { CircularLoading } from "components/utils/circular-loading";
import { LoginClienteFormModel } from "models/app/forms/auth/login-cliente-form-model";
import { LoginFormModel } from "models/app/forms/auth/login-form";
import React from "react";
import { Reenviarcodigo } from "./components/reenviar-codigo/reenviar-codigo";
import { PerfilIcon } from "components/icons/perfil-icon";
import { useStyles } from "./login-styles";
import { SmsCodeIcon } from "components/icons/sms-code-icon";
import { useThemeQueries } from "theme/util-styles";

export type LoginProps = {
    loginRefs: React.RefObject<DefaultFormRefs<LoginFormModel>>
    isCordova: boolean
    isInserirCodigo: { senha: boolean, codigo: boolean } | undefined
    carregando: boolean
    enviarCodigo: (model: LoginClienteFormModel) => void
    autenticacaoCodigo: () => void
    setSenhaOuCodigo: (senhaOuCodigo: { senha: string, codigo: string }) => void
    senhaOuCodigo: { senha: string, codigo: string }
    reenviarNovamente: () => void
}

export const Login = ({ loginRefs, isCordova, isInserirCodigo, carregando, enviarCodigo, autenticacaoCodigo, setSenhaOuCodigo, senhaOuCodigo, reenviarNovamente }: LoginProps) => {

    const classes = useStyles()
    const { isMobile } = useThemeQueries()

    return (
        <Box p={2}>
            <Grid container spacing={2}>
                {carregando && <CircularLoading tipo="FULLSIZED" titulo="Carregando..." />}
                <Grid item xs={12}>
                    {!isMobile && (
                        <Box display="flex" justifyContent="center" marginBottom={2}>
                            {isInserirCodigo?.codigo ? <SmsCodeIcon tipo="GERAL" class={classes.perfilIcon} /> : isInserirCodigo?.senha ? (
                                <PerfilIcon tipo="GERAL" class={classes.perfilIcon} />
                            ) :
                                <PerfilIcon tipo="GERAL" class={classes.perfilIcon} />
                            }
                        </Box>
                    )}
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" align="center">
                        {isInserirCodigo?.codigo ? 'Insira o código enviado para o seu número de telefone para entrar na sua conta' : isInserirCodigo?.senha ? 'Insira sua senha' : 'Faça login e mantenha suas informações salvas para este e os próximos pedidos.'}
                    </Typography>
                </Grid>
                {!isInserirCodigo ? (
                    <Grid item xs={12}>
                        <FormLoginCliente
                            showLoading={false}
                            ref={loginRefs}
                            loading={carregando}
                            onSubmit={(model) => {
                                enviarCodigo(model)
                            }}
                        />
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <Box component="form" onSubmit={(e) => {
                            e.preventDefault()
                            autenticacaoCodigo()
                        }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {isInserirCodigo.codigo ? (
                                        <Box width="100%" display="flex" flexDirection="column">
                                            <InputPin
                                                type="tel"
                                                canFocus={true}
                                                lenght={6}
                                                onChange={(e, value) => setSenhaOuCodigo({ ...senhaOuCodigo, codigo: value })}
                                                allowSubmit

                                                fullWidth={true}
                                                disabled={false}
                                            />
                                            <Box display="flex" justifyContent="flex-end" mt={1}>
                                                <Reenviarcodigo onReenviar={() => reenviarNovamente()} />
                                            </Box>
                                        </Box>
                                    ) : (
                                        <TextFieldSaurus
                                            label="Senha"
                                            value={senhaOuCodigo.senha}
                                            tipo="PASSWORD"
                                            onChange={(e) => setSenhaOuCodigo({ ...senhaOuCodigo, senha: e.target.value })}
                                            allowSubmit
                                            fullWidth={true}
                                            disabled={false}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                            <button type="submit" style={{ display: 'none' }}></button>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}
